export enum ToastNotificationSeverity {
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Error = 'error',
  }
  